import React, { useState } from 'react';
import { TextField, Box, Typography, Stack } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const SignWithPAN = ({ pan, setPan, panNumber }) => {
  const [error, setError] = useState(null);
  const [isValid, setIsValid] = useState(false);

  const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;

  const handlePanChange = (e) => {
    const value = e.target.value.toUpperCase();
    setPan(value);

    if (!value) {
      setError('PAN number is required');
      setIsValid(false);
      return;
    }

    if (value.length !== 10) {
      setError('PAN number must be exactly 10 characters');
      setIsValid(false);
      return;
    }

    if (!panRegex.test(value)) {
      setError('Error: Error : Invalid PAN, Please retry.');
      setIsValid(false);
      return;
    }

    setError(null);
    setIsValid(true);
    panNumber(value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Valid PAN submitted:', pan);
  };

  return (
    <Stack sx={{ maxWidth: 500, mx: 'auto', mt: 4 }}>
      <Typography variant='h5' gutterBottom>
        PAN card verification
      </Typography>

      <Box component='form' onSubmit={handleSubmit} noValidate sx={{ mt: 2 }}>
        <TextField
          fullWidth
          label='PAN Number'
          variant='outlined'
          value={pan}
          onChange={handlePanChange}
          error={!!error}
          helperText={error}
          placeholder='ABCDE1234F'
          inputProps={{
            maxLength: 10,
            style: { textTransform: 'uppercase' },
          }}
          sx={{ mb: 3 }}
        />

        {isValid && (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              color: 'success.main',
              mb: 2,
            }}
          >
            <CheckCircleOutlineIcon sx={{ mr: 1 }} />
            <Typography variant='body2'>Valid PAN format</Typography>
          </Box>
        )}

        {!isValid && pan && (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              color: 'error.main',
              mb: 2,
            }}
          >
            <ErrorOutlineIcon sx={{ mr: 1 }} />
            <Typography variant='body2'>{error}</Typography>
          </Box>
        )}
        {isValid && (
          <Box sx={{ mt: 2, p: 2, bgcolor: 'success.light', borderRadius: 1 }}>
            <Typography variant='body1'>
              PAN number {pan} has been successfully added, please add
              signature!
            </Typography>
          </Box>
        )}
      </Box>

      <Box sx={{ mt: 4 }}>
        <Typography variant='body2' color='text.secondary'>
          Note: A valid PAN follows the format AAAAA0000A where:
        </Typography>
        <ul>
          <Typography component='li' variant='body2' color='text.secondary'>
            First 5 characters are letters (A-Z)
          </Typography>
          <Typography component='li' variant='body2' color='text.secondary'>
            Next 4 characters are numbers (0-9)
          </Typography>
          <Typography component='li' variant='body2' color='text.secondary'>
            Last character is a letter (A-Z)
          </Typography>
        </ul>
      </Box>
    </Stack>
  );
};

export default SignWithPAN;
